import { styled } from '@mui/material/styles';
import { Box, Button, Paper, Table, TableCell, TableHead, TableRow, Tabs, Typography } from '@mui/material';

// ============================================
// Layout
// ============================================
export const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
});

export const TabsWrapper = styled(Box)({
  marginTop: '12.5px',
  paddingBottom: 0,
  height: '40px',
});

export const Card = styled(Paper)({
  background: '#fff',
  borderRadius: '10px',
  padding: '30px 40px',
});

// 엑셀 다운로드 + 페이지 개수 선택을 우측 정렬
export const ToolbarRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '10px',
  marginBottom: '20px',
});

// 표(내역 영역) 위에 놓이는 필터 행 — 상품/변경종류 드롭다운 + 우측 끝 건수
export const FilterBar = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '32px',
  marginBottom: '16px',
});

// 라벨 + 드롭다운 한 쌍 (예: "상품  [전체 ▼]")
export const FilterGroup = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const FilterLabel = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  whiteSpace: 'nowrap',
});

// 현재 조회 조건의 전체 건수 — 필터 행 우측 끝으로 밀어내고,
// 헤더 우측 프로필 아바타 중심선과 가로 위치를 맞춤(예약 내역과 동일).
// 헤더 우측 패딩 32px + 아바타 반지름 20px - 본문 우측 패딩 20px = 32px 안쪽
export const TotalCount = styled(Typography)({
  marginLeft: 'auto',
  marginRight: '32px',
  fontSize: '14px',
  fontWeight: 600,
  color: '#555',
});

// ============================================
// Sub Tabs (만료일연장 내역 / 상품중지 내역)
// ============================================
export const StyledTabs = styled(Tabs)({
  '& .MuiTab-root.MuiTab-textColorSecondary': {
    borderRadius: '12px',
    border: '1px solid #4AB3BC',
    marginRight: '10px',
    minWidth: '100px',
    minHeight: '40px !important',
    padding: '12px 40px',
    fontWeight: 500,
    fontSize: '18px',
  },
  '& .MuiTab-root.MuiTab-textColorSecondary.Mui-selected': {
    background: '#4AB3BC',
    borderRadius: '12px',
    border: 'none',
    color: '#fff',
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
});

// ============================================
// Table
// ============================================
export const StyledTableContainer = styled(Box)({
  border: '1px solid #ddd',
  overflow: 'auto',
});

// 컬럼이 9개라 좁은 화면에서는 줄바꿈 대신 가로 스크롤(StyledTableContainer overflow:auto)로 버틴다.
export const StyledTable = styled(Table)({
  minWidth: 900,
});

export const StyledTableHead = styled(TableHead)({
  background: '#fafbfc',
});

export const HeaderCell = styled(TableCell)({
  fontSize: '12px',
  fontWeight: 500,
  whiteSpace: 'nowrap',
  borderRight: '1px solid #ddd',
  '&:last-child': {
    borderRight: 'none',
  },
});

export const BodyRow = styled(TableRow)({
  '&:last-child td, &:last-child th': { borderBottom: 0 },
  '&:hover': { background: '#f0f0f0' },
});

// 날짜·이름·구분은 한 줄 고정. 메모처럼 긴 값만 wrap 컬럼으로 표시해 줄바꿈을 허용한다.
export const BodyCell = styled(TableCell, {
  shouldForwardProp: prop => prop !== 'wrap',
})(({ wrap }) => ({
  fontSize: '13px',
  whiteSpace: wrap ? 'normal' : 'nowrap',
  ...(wrap ? { minWidth: 140, wordBreak: 'break-all' } : {}),
  borderRight: '1px solid #ddd',
  '&:last-child': {
    borderRight: 'none',
  },
}));

export const EmptyCell = styled(TableCell)({
  padding: '60px 0',
  textAlign: 'center',
  color: '#9e9e9e',
  fontSize: '14px',
});

// ============================================
// 연장취소 Button (행 단위)
// ============================================
export const CancelButton = styled(Button)({
  minWidth: '52px',
  height: '30px',
  padding: '0 14px',
  borderRadius: '5px',
  fontSize: '13px',
  border: '1px solid #F0A0A0',
  background: '#fff',
  color: '#E05858',
  '&:hover': {
    background: '#FDECEC',
    border: '1px solid #E05858',
  },
  '&.Mui-disabled': {
    border: '1px solid #e8e8e8',
    color: '#bdbdbd',
  },
});
